import { ReactNode } from 'react';
import { Navigate, Outlet } from '@tanstack/react-router';
import { useAuthData } from '@anytag/auth';
import { UserRoles } from '@anytag/graphql';
import { InitialLoading } from '@anytag/shared-molecules';

export interface PermissionRouteProps {
  permissions?: UserRoles[];
  element?: ReactNode;
}

export const PermissionRoute = ({ permissions = [], element = <Outlet /> }: PermissionRouteProps) => {
  const {
    auth: { role, status, company }
  } = useAuthData();

  if (status === 'idle') {
    return <InitialLoading />;
  }

  if (role === UserRoles.ADVERTISER && company === 'TIKTOK') {
    return <Navigate to="/tiktok/ad-campaign-report" />;
  }

  if (!role || (permissions.length > 0 && !permissions.includes(role))) {
    return <Navigate to="/not-found" />;
  }

  return element;
};
